import { useCallback, useRef, useState } from "react";
import { useWebSocketContext } from "../contexts/WebSocketProvider";

export default function useAddRfid() {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);

  const { send, isConnected, connect } = useWebSocketContext();
  const mountedRef = useRef(true);

  const addRfid = useCallback(
    async ({ group_id, phone, rfid, expiry_date, admin_user_id }) => {
      if (!mountedRef.current) return;

      setIsLoading(true);
      setError("");
      setSuccess(false);

      try {
        if (!isConnected) {
          await connect();
        }

        const payload = {
          group_id,
          phone,
          rfid,
          admin_user_id, // REQUIRED
        };

        // Only add expiry_date if provided
        if (expiry_date) {
          payload.expiry_date = expiry_date;
        }

        const response = await send("cms_set_rfid_for_group", payload);

        if (!response || response.type !== "cms_set_rfid_for_group_response") {
          throw new Error("Invalid response from server");
        }

        if (!response.status) {
          throw new Error(response.message || "Failed to add RFID");
        }

        setSuccess(true);
        return response.data;
      } catch (err) {
        setError(err.message || "Failed to add RFID");
        throw err;
      } finally {
        if (mountedRef.current) setIsLoading(false);
      }
    },
    [isConnected, connect, send]
  );

  return {
    addRfid,
    isLoading,
    error,
    success,
  };
}